export default "__VITE_ASSET__7c4cc8ea__"